<script>
import ReportConfirmMangerModalVue from '@/app/arch/components/modals/ReportConfirmMangerModal.vue';
import UsersRequest from '../../UsersRequest';

export default {
  name: 'UsersReportButton',
  extends: ReportConfirmMangerModalVue,
  data: () => ({
    requestClass: UsersRequest,
    totalItens: 0,
    btnText: 'Exportar usuários',
    successMessage: 'Usuários exportadas com sucesso!',
    crudListName: 'UserList',
  }),
  computed: {
    faultReportParams() {
      return {
        isActive: true,
      };
    },
  },
};
</script>
